export default __webpack_public_path__ + "static/flower_2-5a74f0e6be77655296bdb37e5d706e25.png";